"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ClassificationTableFooter_1 = tslib_1.__importDefault(require("../ClassificationTableFooter"));
var Classification_helpers_1 = require("../../Classification.helpers");
var TableData_1 = require("./TableData");
var EditModeTableData = function (_a) {
    var classifications = _a.classifications, classificationDetails = _a.classificationDetails, isDataEdited = _a.isDataEdited, isSubmitting = _a.isSubmitting, setIsDataEdited = _a.setIsDataEdited, selectedAsOfDate = _a.selectedAsOfDate, onBlurGridData = _a.onBlurGridData, setEditedClassificationValues = _a.setEditedClassificationValues, previousDateGridData = _a.previousDateGridData;
    var _b = react_1.useState(classifications), editableData = _b[0], setEditableData = _b[1];
    react_1.useEffect(function () {
        if (JSON.stringify(classifications) !== JSON.stringify(editableData)) {
            if (setIsDataEdited) {
                setIsDataEdited(true);
            }
        }
    }, [classifications, editableData]);
    react_1.useEffect(function () {
        var _a;
        if ((selectedAsOfDate === null || selectedAsOfDate === void 0 ? void 0 : selectedAsOfDate.newDate) &&
            !selectedAsOfDate.newDateWithExistingClassification) {
            var emptyClassifications = (_a = classificationDetails === null || classificationDetails === void 0 ? void 0 : classificationDetails.Classes) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.ID !== 1000000 && item.ID !== 1000001; }).map(function (item) {
                return {
                    ID: item.ID,
                    Name: item.Name,
                    SortOrder: item.SortOrder,
                    Long: null,
                    Short: null,
                    Gross: null,
                    Net: null,
                };
            });
            setEditableData(emptyClassifications);
            setEditedClassificationValues === null || setEditedClassificationValues === void 0 ? void 0 : setEditedClassificationValues(emptyClassifications);
        }
        else {
            setEditableData(classifications);
            setEditedClassificationValues === null || setEditedClassificationValues === void 0 ? void 0 : setEditedClassificationValues(classifications);
        }
    }, [selectedAsOfDate]);
    react_1.useEffect(function () {
        if (previousDateGridData !== undefined) {
            setEditableData(previousDateGridData);
        }
    }, [previousDateGridData]);
    var handleOnBlur = react_1.useCallback(function (row, value, field) {
        var valueToCalculate = Number(value) > 0 ? Number(value) : null;
        var _a = Classification_helpers_1.calculateRow(field, row, valueToCalculate), Long = _a.Long, Short = _a.Short, Gross = _a.Gross, Net = _a.Net;
        var calculated = editableData === null || editableData === void 0 ? void 0 : editableData.map(function (item) {
            if (item.ID === row.ID) {
                var rowToUpdate = tslib_1.__assign(tslib_1.__assign({}, item), { Long: !Number.isNaN(Number(Long === null || Long === void 0 ? void 0 : Long.toFixed(3)))
                        ? Number(Long === null || Long === void 0 ? void 0 : Long.toFixed(3))
                        : null, Short: !Number.isNaN(Number(Short === null || Short === void 0 ? void 0 : Short.toFixed(3)))
                        ? Number(Short === null || Short === void 0 ? void 0 : Short.toFixed(3))
                        : null, Gross: !Number.isNaN(Number(Gross === null || Gross === void 0 ? void 0 : Gross.toFixed(3)))
                        ? Number(Gross === null || Gross === void 0 ? void 0 : Gross.toFixed(3))
                        : null, Net: !Number.isNaN(Number(Net === null || Net === void 0 ? void 0 : Net.toFixed(3)))
                        ? Number(Net === null || Net === void 0 ? void 0 : Net.toFixed(3))
                        : null, SortOrder: item.SortOrder });
                onBlurGridData === null || onBlurGridData === void 0 ? void 0 : onBlurGridData(rowToUpdate);
                return rowToUpdate;
            }
            return item;
        });
        if (JSON.stringify(calculated) !== JSON.stringify(editableData)) {
            setEditableData(tslib_1.__spreadArrays(calculated));
        }
    }, [editableData, onBlurGridData]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableData_1.TableData, { data: editableData, handleOnBlur: function (classification, value, field) { return handleOnBlur(classification, value, field); }, selectedAsOfDate: selectedAsOfDate }),
        react_1.default.createElement(ClassificationTableFooter_1.default, { classifications: editableData })));
};
exports.default = EditModeTableData;
